<template>
  <div>
    <identity-verification-form
      :form-model="formModel"
      :person-title="locale.branches.theBranch"
      :view-mode="loading"
      :firms-only="true"
      :manager-social-id-required="false"
    ></identity-verification-form>
  </div>
</template>

<script>
import IdentityVerificationForm from '../../../identity-verification-form.vue';

export default {
  inject: ['$validator'],
  components: { IdentityVerificationForm },
  props: {
    formModel: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    loading: {
      type: Boolean,
      required: true,
      default: () => false,
    },
  },
  data() {
    return { locale: this.local.bankruptcy.requestDetails };
  },
  computed: {},
  methods: {},
};
</script>

<style lang="scss" scoped>
</style>
